import cloneDeep from 'lodash/cloneDeep'
import { CHECKBOX_FILTERS } from 'apps/booking/constants/checkboxFilters'
import { POD_IDS_LEGACY, POD_IDS_NEW } from 'apps/booking/constants/podIds'
import {
  FILTERS_UPDATE,
  FILTERS_SUBMIT_SUCCESS,
  FILTERS_SUBMIT_FAILURE,
  CLEAR_CHECKBOX_FILTERS,
} from 'apps/booking/utils/actions/filters'
import { updateFiltersState } from 'apps/booking/utils/filters'
import { updateSearchParams } from 'apps/booking/utils/searchParams'

export const defaultState = {
  pickupLocation: { city: '', state: '', postalCode: '' },
  deliveryLocation: { city: '', state: '', postalCode: '' },
  pickupRegion: '',
  deliveryRegion: '',
  pickupDates: [],
  deliveryDates: [],
  query: '',
  radius: '',
  brokerPodKey: null,
  usersId: null,
  usersType: null,
  myLoads: false,
  equipment: '',
  multiFilter: false,
  podIds: POD_IDS_LEGACY,
  podIdsNew: POD_IDS_NEW,
  checkboxFilters: CHECKBOX_FILTERS,
  company: null,
  stateOptions: '',
  status: '',
  pickupDateRange: false,
  deliveryDateRange: false,
  needsTracking: false,
  shipperRateType: '',
  pricingType: '',
  issueState: '',
  separateRegionsForBooking: false,
}

const filtersReducer = (state = defaultState, action = {}) => {
  switch (action.type) {
    case FILTERS_UPDATE: {
      const {
        payload: { filters, separateRegionsForBooking },
      } = action
      const updatedFilters = {}
      Object.keys(filters).forEach(key => {
        const update = updateFiltersState(key, filters[key], state)
        Object.assign(updatedFilters, update)
      })
      const updatedState = { ...state, ...updatedFilters, separateRegionsForBooking }
      const formatSearchParams = updateSearchParams(updatedState)
      return {
        ...updatedState,
        searchParams: { ...formatSearchParams },
      }
    }
    case FILTERS_SUBMIT_SUCCESS: {
      const {
        payload: { data },
      } = action
      return {
        ...state,
        data,
      }
    }
    case FILTERS_SUBMIT_FAILURE: {
      const {
        payload: { error },
      } = action
      return {
        ...state,
        error,
      }
    }
    case CLEAR_CHECKBOX_FILTERS:
      return {
        ...state,
        checkboxFilters: cloneDeep(defaultState.checkboxFilters).map(filter => ({
          ...filter,
          selected: filter.value === action.selected,
        })),
      }
    default:
      return state
  }
}

export default filtersReducer
